import { createIdentifier } from '../../../utils/general';

export const transactionTypeDetermination = (isFix, isReleasing) => {
  const identifier = createIdentifier([isFix, isReleasing]);
  switch (identifier) {
    case 0:
      return 'BUY';
    case 1:
      return 'SALE';
    case 2:
      return 'FIXING';
    case 3:
      return 'RELEASE';
    default:
      return 'BUY';
  }
};
